export default __webpack_public_path__ + "static/media/SWT1000.34I-29563_-17087_0.14a0a1bb.jpg";